import { render, staticRenderFns } from "./AppLogs.vue?vue&type=template&id=22bd3f82&scoped=true"
import script from "./AppLogs.vue?vue&type=script&lang=js"
export * from "./AppLogs.vue?vue&type=script&lang=js"
import style0 from "./AppLogs.vue?vue&type=style&index=0&id=22bd3f82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bd3f82",
  null
  
)

export default component.exports